import React from "react";
import Routes from "./Routes";
import { AuthProvider } from './AuthContext';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return <AuthProvider>
    <Routes />
    <ToastContainer />
    </AuthProvider>;
}

export default App;
